module.exports = __webpack_public_path__ + "img/land_characteristics_plain.eb535e67.png";